// extracted by mini-css-extract-plugin
module.exports = {"stageWrap":"MilestoneTasksGroupStage_stageWrap__2kzet","addTaskBtn":"MilestoneTasksGroupStage_addTaskBtn__3aiCC"};